import * as tslib_1 from "tslib";
import styled from 'styled-components';
var gutter = 4;
export default styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  margin: 0 -", "px;\n"], ["\n  display: inline-flex;\n  margin: 0 -", "px;\n"])), gutter / 2);
export var GroupItem = styled.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex: 1 0 auto;\n  margin: 0 ", "px;\n"], ["\n  flex: 1 0 auto;\n  margin: 0 ", "px;\n"])), gutter / 2);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonGroup.js.map